import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Auth, onAuthStateChanged, User } from '@angular/fire/auth';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private auth: Auth) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return new Promise((resolve) => {
            onAuthStateChanged(this.auth, (user: User | null) => {                
                if(state.url.startsWith('/confirmation')) {
                    resolve(true);
                }
                else {
                    if (user) {
                        resolve(true);
                    } else {
                    let queryParams = {};
                    
                        if(state.url !== '/dashboard') {
                            queryParams = { returnUrl: state.url };
                        }
                        this.router.navigate(['/auth/login'], {
                            queryParams
                        });
                        resolve(false);
                    }
                }                
            });
        });        
    }
}
